import { ReactNode, Suspense } from 'react';
import { Provider } from 'react-redux';
import { store } from '@/store/index';
import { MantineProvider } from './MantineProvider';
import { QueryProvider } from './QueryProvider';
import { ContentProvider } from './ContentProvider';
import { DatesProvider } from './DatesProvider';

export const AppProviders = ({ children }: { children: ReactNode }) => {
	return (
		<Provider store={store}>
			<MantineProvider>
				<QueryProvider>
					<ContentProvider>
						<DatesProvider>
							<Suspense fallback={<></>}>{children}</Suspense>
						</DatesProvider>
					</ContentProvider>
				</QueryProvider>
			</MantineProvider>
		</Provider>
	);
};
